export default { 
  apiKey: "AIzaSyDNvOX98_jOkxltMyobJanexBgntDrmD1c",
  authDomain: "secretoapp-c0d35.web.app",
  databaseURL: "https://secretoapp-c0d35.firebaseio.com",
  projectId: "secretoapp-c0d35",
  storageBucket: "secretoapp-c0d35.appspot.com",
  messagingSenderId: "382986925874"
}


// WEBPACK FOOTER //
// ./src/components/firebaseConfig.js